import React from 'react';
import styled from 'styled-components';

// Styled Components
const Container = styled.div`
  max-width: 800px;
  margin: 5px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

// Refund And Cancellation Component
const RefundAndCancellation = () => {
  return (
    <Container>
      <Title>Refund and Cancellation Policy</Title>

      <Section>
        <Paragraph>
          You acknowledge that (1) your cancellation, or attempted or purported cancellation,
          of an order or (2) cancellation due to any reasons not attributable to Colab Kitchen,
          a Restaurant Partner, or a Delivery Partner, shall amount to a breach of your
          unconditional and irrevocable authorization in favor of Colab Kitchen to place that
          order against the Restaurant Partner(s)/Store(s) on your behalf (“Authorization Breach”).
          In the event you commit an Authorization Breach, you shall be liable to pay the liquidated 
          damages of an amount equivalent to the order value. You hereby authorize Colab Kitchen to 
          deduct or collect the amount payable as liquidated damages through such means as Colab Kitchen 
          may determine in its discretion, including without limitation, by deducting such amount from 
          any payment made towards your next Order.
        </Paragraph>

        <Paragraph>
          There may be cases where Colab Kitchen is either unable to accept your order or cancels 
          the order, due to reasons including without limitation, technical errors, unavailability 
          of the item(s) ordered, or any other reason attributable to Colab Kitchen, Restaurant 
          Partner/Store or Delivery Partner. In such cases, Colab Kitchen shall not charge a cancellation 
          charge from you. If the order is cancelled after payment has been charged and you are eligible 
          for a refund of the order value or any part thereof, the said amount will be reversed to you.
        </Paragraph>

        <Paragraph>
          No replacement / refund / or any other resolution will be provided without Restaurant 
          Partner’s/Store(s)’ permission.
        </Paragraph>

        <Paragraph>
          Any complaint, with respect to the order which shall include instances but not be limited 
          to food spillage, foreign objects in food, delivery of the wrong order or food and beverages 
          or Products, poor quality, You will be required to share the proof of the same before any 
          resolution can be provided.
        </Paragraph>

        <Paragraph>
          You shall not be entitled to a refund in case instructions placed along with the order are 
          not followed in the form and manner You had intended. Instructions are followed by the Restaurant 
          Partner/Store on a best-efforts basis.
        </Paragraph>

        <Paragraph>
          All refunds shall be processed in the same manner as they are received, unless refunds have 
          been provided to You in the form of credits, refund amount will reflect in your account based 
          on respective banks' policies. Refund will be credited to the customer in 10 days' time.
        </Paragraph>
      </Section>
    </Container>
  );
};

export default RefundAndCancellation;
